__turbopack_context__.v({
  "className": "cormorant_garamond_cb39150-module__y1d01q__className",
  "variable": "cormorant_garamond_cb39150-module__y1d01q__variable",
});
